import externalLinkIcon from 'assets/icons/external-link.svg'
import { Modal } from 'components/Modal'
import { getWorkstreamDetailModalData } from 'constants/WorkingModePathwaysDetailModals'

import { DetailSubsectionBlock, StepsList } from './DetailModalParts'
import { ModalHeader } from './ModalHeader'

interface SprintWorkstreamDetailModalProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

const renderOutputText = (text: string, boldPhrases?: string[]) => {
  if (!boldPhrases || boldPhrases.length === 0) return <p className="body-xs w-full">{text}</p>

  const pattern = boldPhrases.map(phrase => phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
  const parts = text.split(new RegExp(`(${pattern})`, 'g'))

  return (
    <p className="body-xs w-full">
      {parts.map((part, index) =>
        boldPhrases.includes(part) ? (
          <span key={index} className="font-bold">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </p>
  )
}

export const SprintWorkstreamDetailModal = ({ isOpen, onClose, id }: SprintWorkstreamDetailModalProps) => {
  const data = getWorkstreamDetailModalData(id)
  if (!data) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="workstream-detail-modal">
      <ModalHeader title={data.title} onClose={onClose} />

      <div className="sprint-detail-columns">
        <div className="sprint-detail-main">
          <div className="sprint-detail-input" style={{ background: data.inputBgColor }}>
            <p className="subtitle-xl w-full">{data.column1Heading}</p>
            <div className="sprint-detail-input-row">
              {data.subsections.flatMap((subsection, index) => [
                <div key={subsection.label} className="flex-1 min-w-0">
                  <DetailSubsectionBlock subsection={subsection} />
                </div>,
                index < data.subsections.length - 1 && (
                  <div key={`divider-${subsection.label}`} className="sprint-divider-vertical" />
                ),
              ])}
            </div>
          </div>

          <div className="sprint-detail-row2">
            <div className="sprint-detail-card" style={{ background: data.teamBgColor }}>
              <p className="subtitle-xl">Team</p>
              <p className="body-xs w-full">{data.teamParagraph}</p>
              {data.teamNote && <p className="body-xs font-bold w-full">{data.teamNote}</p>}
            </div>

            <div className="sprint-detail-subcol">
              <div className="sprint-detail-card" style={{ background: data.sessionToolsBgColor }}>
                <p className="subtitle-xl whitespace-nowrap">Session Tools</p>
                <div className="text-right">
                  <a
                    href="https://app.mural.co/t/reborrn0190/m/reborrn0190/1741803875130/917b26cb6886cf897e1b7145046bcdb99e8249d8?sender=u63412ace9107fd7363ca8493"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-black border border-solid body-s font-bold px-[16px] py-[6px] inline-flex items-center gap-2"
                  >
                    Mural
                    <img src={externalLinkIcon} alt="" width={16} height={16} />
                  </a>
                </div>
              </div>

              <div className="sprint-detail-card" style={{ background: data.sessionToolsBgColor }}>
                <p className="subtitle-xl">Output</p>
                {renderOutputText(data.outputText, data.outputTextBoldPhrases)}
              </div>
            </div>
          </div>
        </div>

        <div className="sprint-detail-steps" style={{ background: data.stepsBgColor }}>
          <StepsList steps={data.steps} />
        </div>
      </div>
    </Modal>
  )
}
